import { ChangeEvent, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Stack } from '@mui/material';
import isEmpty from 'lodash/isEmpty';

import { useMids } from 'src/api/hooks';
import { ActionsCard } from 'src/components/TablePage/ActionsCard';
import { PAGE_SIZE, routes } from 'src/constants';
import { Pagination } from 'src/components/Pagination';
import { MidsTable, MidsFiltersModal } from 'src/components/Mids';
import { useHistory } from 'react-router';

export const MIDs = () => {
    const { fetchMids, mids, loading, paging, deleteMid } = useMids();

    const history = useHistory();

    const MENU_ITEMS = [
        {
            title: 'Add MID',
            onClick: () => history.push(routes.midNew)
        }
    ];

    const { totalPages } = paging || {};
    const [pageNumber, setPageNumber] = useState(0);
    const [searchString, setSearchingString] = useState('');

    const [modalVisible, setModalVisible] = useState(false);
    const hideModal = () => setModalVisible(false);
    const openModal = () => setModalVisible(true);

    const { handleSubmit, control, reset } = useForm<any>();
    const [filterFormState, setFilterFormState] = useState<any>();
    const [filter, setFilter] = useState<string>('');

    const getMids = (pageNumber: number, innerSearchString?: string) => {
        fetchMids({
            searchString: innerSearchString ?? searchString,
            pageNumber: `${pageNumber}`,
            pageSize: PAGE_SIZE,
            filter
        });
    };

    useEffect(() => {
        getMids(pageNumber);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handlePageChange = (e: ChangeEvent<unknown>, page: number) => {
        setPageNumber(page - 1);
        getMids(page - 1);
    };

    const handleSearchChange = (searchString?: string) => {
        setSearchingString(searchString || '');
        getMids(0, searchString);

        if (pageNumber) {
            setPageNumber(0);
        }
    };

    const handleRefresh = () => {
        setFilterFormState(undefined);
        setFilter('');
        reset({});
        fetchMids({
            searchString: searchString,
            pageNumber: `${pageNumber}`,
            pageSize: PAGE_SIZE
        });
    };

    const handleDeleteMid = (id: string) => {
        deleteMid(id, {
            searchString,
            pageNumber: '0',
            pageSize: PAGE_SIZE
        });
        setPageNumber(0);
    };

    const handleOpenFilterModal = () => {
        openModal();
    };

    const applyFilter = (filter: string) => {
        setPageNumber(0);
        setFilter(filter);
        return fetchMids({
            searchString,
            pageNumber: '0',
            pageSize: PAGE_SIZE,
            filter
        });
    };

    const handleCancelFilter = () => {
        reset(filterFormState);
        hideModal();
    };

    return (
        <Stack spacing={2}>
            <ActionsCard
                onSearchChange={handleSearchChange}
                onRefresh={handleRefresh}
                openFilter={handleOpenFilterModal}
                actionsMenuItems={MENU_ITEMS}
                title="MIDs"
            />
            <MidsTable
                data={Object.values(mids)}
                loading={loading}
                onDelete={handleDeleteMid}
            />
            {!isEmpty(mids) && (
                <Pagination
                    page={pageNumber + 1}
                    onChange={handlePageChange}
                    count={totalPages}
                />
            )}
            <MidsFiltersModal
                open={modalVisible}
                onClose={hideModal}
                applyFilter={applyFilter}
                onCancel={handleCancelFilter}
                handleSubmit={handleSubmit}
                setFilterFormState={setFilterFormState}
                control={control}
            />
        </Stack>
    );
};
